export const FREEDOM_CRM_API="https://api.monopolymoney.com"
export const FREEDOM_CRM_SITE_ID="monopolymoney.com"
